import React, { Component } from 'react'

import Menu from './Menu'
import RedSocial from './redsocial'
import Contact from './contact'
import renderHTML from 'react-render-html';

import { connect } from 'react-redux'
import { 
    initLocation, 
    initMenuAsync,
    initPostClear,
    searchAsyncbyCountry,
    getPageAsyncbyCountry
  } from './actions'


class App extends Component {
  constructor(props){
    super(props)
    this.state = {
      postObj:[],
      menu:[],
      loading: true,
      domain: window.location.hostname,
      logo: `${window.location.hostname}/wp-content/themes/beisbolplay/images/logo.png`,
      menuSel:'',
      selectDest: [],
      selectBrand: [],
      selectCase: [],
      total:0,
      term:'',
      page:2,
    }
    this.handlescroll = this.handlescroll.bind(this)
    this.onKeypress = this.onKeypress.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  componentDidMount(){
    this.props.getLocation()
    this.props.getMenuInit()
    window.addEventListener('scroll', this.handlescroll)
    if(this.props.match.params.searchPath.length > 1){
      this.setState({
        term: this.props.match.params.searchPath
      });
    }
    
  }

  componentWillReceiveProps(next_props) {
    if(next_props.country.location !== this.state.country){
      let nameMenu = `menu-${next_props.country.idtag.slug}`
      let idCo = next_props.country.idtag.term_id
      this.setState({
        country: next_props.country.location,
        menuSel: nameMenu,
        tagidLoc: next_props.country.idtag.term_id,
        defaultCountry: idCo,
        selectDest: [],
        selectBrand: [],
        selectCase: []
      })
      this.props.clearPost()
      this.props.getSearch(this.props.match.params.searchPath, next_props.country.idtag.term_id)
    }

    if(next_props.post !== this.state.postObj){
      this.setState({
        total: (typeof(next_props.post) !== 'undefined')?next_props.post.length:0,
        postObj: next_props.post.sort(function(a, b){return b.id-a.id})
      });
    }

    if(next_props.match.params.searchPath !== this.state.term){
      if(next_props.match.params.searchPath.length > 1){
        this.props.getSearch(next_props.match.params.searchPath, next_props.country.idtag.term_id)
        this.setState({
          term: next_props.match.params.searchPath
        });
      }
    }
  }

  handlescroll(event){
    if(!this.state.loading) return null

    const scrolled = window.scrollY
    const viewportHeight = window.innerHeight
    const fullHeight = document.body.clientHeight

    //console.log(!(scrolled + viewportHeight + 300 >= fullHeight))

    if (!(scrolled + viewportHeight + 300 >= fullHeight)){
      return null
    }

    if(this.state.page <= this.props.pageTotal){
      this.setState({ loading: true}, async () => {
        try{
          this.props.getSearchPost(this.state.term, this.state.page, this.state.tagidLoc) 
          this.setState({ 
            loading: true,
            page: this.state.page + 1
          })
        }
        catch (error){
          this.setState({ loading: false })
        }
      })
    }
  }

  onKeypress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.props.getSearch(event.currentTarget.value, this.state.tagidLoc)
      this.setState({
        term: event.currentTarget.value
      });
      this.props.history.push(`/search/${event.currentTarget.value}`)
    }
  }

  onClick(event){
    event.preventDefault()
    let termstring = document.getElementById('input-search').value
    let term = termstring.replace(/<\/?[^>]+(>|$)/g, "")
    this.props.getSearch(term, this.state.tagidLoc)
    this.setState({
      term: term
    });
    this.props.history.push(`/search/${term}`)
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <div className="">
            <div className="row">
              <div className="col s12 m11 offset-m1 l9 offset-l3 logo">
                <Contact search={false}/>
                <RedSocial search={false}/>
                <Menu slug='locations' select={true} col={12} scrollMenu={false} changeGeo={true} defCountry={this.state.defaultCountry}/>
              </div>
              <div className="col s12 m12 l12 nav_principal">
                <Menu slug={this.state.menuSel}  col={12} scrollMenu={true}/>
              </div>
            </div>
          </div>
        </header>
        <section>
          <div className="col s12 cont-search">
            <div className="container">
              <div className="row">
                <div className="search-cont">
                  <div className="form-cont">
                    <form className="fas" id="form-search">
                      <input id="input-search" type="search" placeholder="Search" defaultValue={this.state.term} onKeyPress={this.onKeypress}/>
                    </form>
                    <button onClick={this.onClick}>
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="result-cont">
                  { this.state.term !== '' &&
                    <h3>Se encontraron {this.state.total} resultados por {this.state.term}</h3>
                  }

                  { this.state.term  === '' &&
                    <h3>Tenemos estas sugerencias</h3>
                  }
                </div>
                <div className="result-items">
                {
                  this.state.postObj.map((item, i) => {
                    let imgitem = ''
                    if(item._embedded.hasOwnProperty('wp:featuredmedia')){
                      item._embedded['wp:featuredmedia'].map((img)=>{
                        if(img.hasOwnProperty('media_details')){
                          if(img.media_details.hasOwnProperty('sizes')){
                            console.log(img.media_details.sizes)
                            if(img.media_details.sizes.hasOwnProperty('thumbnail')){
                              if(img.media_details.sizes.thumbnail.hasOwnProperty('source_url')){
                                imgitem = img.media_details.sizes.thumbnail.source_url
                              }
                            }
                          }
                        }
                        return true
                      })
                    }
                    
                    
                    return (
                      <div className="item-post" key={i}>
                        <div className="row">
                        { imgitem !== '' &&
                          <div className="col s12 m2 l2">
                            <div className={(item.video_field.length > 0) ? 'item-post-img-play' : 'item-post-img'}>
                              {
                                <a href={item.link}><img src={imgitem} alt="item.title"/></a>
                              }
                            </div>
                          </div>
                        }
                        { item.featured_media > 0 &&
                          <div className="col s12 m10 l10">
                            <div className="item-post-title">
                              <a href={item.link}><h3>{renderHTML(item.title.rendered)}</h3></a>
                            </div>
                            <div className="item-post-cont">
                              <div>{renderHTML(item.excerpt.rendered)}</div>
                            </div>
                          </div>
                        }
                        { item.featured_media === 0 &&
                          <div className="col s12 m12 l12">
                            <div className="itemm-post-title">
                              <h3>{renderHTML(item.title.rendered)}</h3>
                            </div>
                            <div className="item-post-cont">
                              <div>{renderHTML(item.excerpt.rendered)}</div>
                            </div>
                          </div>
                        }

                        </div>
                      </div>
                    )
                  })
                }
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer>
          <div className="cont_log_footer">
            <div className="container">
              <div className="row">
                <div className="col s12 m7 text_vc">
                  <p>COPYRIGHT @ VC MEDIOS C.A. 2018 > TODOS LOS DERECHOS RESERVADOS</p>
                  <p><a href="/terminos-y-condiciones-politica-de-privacidad/">TERMINOS Y CONDICIONES</a> | <a href="/terminos-y-condiciones-politica-de-privacidad/">POLITICAS DE PRIVACIDAD</a></p>
                </div>
                <div className="col s12 m5 brand_vc">
                  <img className="col s6" src="/assets/images/logo_vc_footer_b.png"  alt=""/>
                  <img className="col s6" src="/assets/images/logo_vcDigital_footer_b.png"  alt=""/>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

function mapStateToProps (reducer){
  return {
    pageTotal: reducer.page,
    post: reducer.post,
    menus: reducer.menus,
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
    getMenuInit: (data) => dispatch(initMenuAsync(data)),
    getSearch: (data, excludeContry) => dispatch(searchAsyncbyCountry(data, excludeContry)),
    getSearchPost: (string, data, excludeContry) => dispatch(getPageAsyncbyCountry(string, data, excludeContry)),
    clearPost: (data) => dispatch(initPostClear(data)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(App)



// WEBPACK FOOTER //
// ./src/Search.js